import fetchAPI from '../fetchAPI';

export const callDeleteUser = async (id: string): Promise<iResponse<User>> => {
  const response: iResponse<User> = await fetchAPI({
    method: `DELETE`,
    route: `user/${id}`
  });

  // const {error} = response;
  // if (error) throw new ResponseError(error);

  return response;
};

export default callDeleteUser;
